const riot = require('riot');

riot.tag2('popup-record-list', '<div class="w300 bg-white rounded-8 box-shadow overflow-hidden" if="{templates.length || recentHistoryRecords.length}" ref="popup" onkeydown="{selectionList.onKeyDown}"> <div if="{recentHistoryRecords.length}"> <div class="px12 fs12 bold text-primary bg-primary_pale py4">履歴</div> <div data-is="item-selection-list" each="{item in recentHistoryRecords}" item="{item}" onclick="{onSelect}"> <div data-is="item-candidate_" item="{item}"></div> </div> </div> <div if="{templates.length}"> <div class="px12 fs12 bold text-primary bg-primary_pale py4">テンプレート</div> <div class="max-height-200 overflow-y-scroll"> <div data-is="item-selection-list" each="{item in templates}" item="{item}" onclick="{onSelect}"> <div data-is="item-candidate_" item="{item}"></div> </div> </div> </div> </div>', '', '', function(opts) {
    this.mixin('selectionList');
    this.on('mount', () => {
      this.templates = this.opts.templates;
    });
    this.recentHistoryRecords = this.opts.recentHistoryRecords;

    this.onSelect = (e) => {
      this.trigger('select', e.item.item);
      this.close();
    };

    this.setTemplates = (items) => {
      this.templates = this.getUniqueItems(items);
      this.update();
    };

    this.setRecentHistoryRecords = (items) => {
      this.recentHistoryRecords = this.getUniqueItems(items).slice(0,3);
      this.update();
    };

    this.getUniqueItems = (items) => {
      return app.utils.unique(items, (item) => {
        let strings = [
          item.data.title,
          item.data.project_ref?.id,
          item.data.tags?.join(','),
        ];
        return strings.join("\n");
      });
    };

    this.on('selectionList.keydown.enter', (e) => {

      var items = (this.recentHistoryRecords || []).concat(this.templates || []);

      if (!items.length) return this.close();
      e.preventDefault();
      var index = this.selectionList.selectedIndex;
      var item = items[index];
      this.trigger('select', item);
      this.close();
    });

});
riot.tag2('item-candidate_', '<div class="f fm py6 px12 border-bottom hover-trigger hover-bg-label_pale overflow-hidden cursor-pointer" if="{!opts.item.relation.project || opts.item.relation.project &amp;&amp; opts.item.relation.project.doc.exists}"> <div class="line-clamp-1 word-break-all mr12 mr0-last" if="{opts.item.data.title}">{opts.item.data.title}</div> <div class="f fm flex-fixed fs12 mr12 mr0-last" if="{opts.item.relation.project &amp;&amp; opts.item.relation.project.doc.exists}" riot-style="color: {opts.item.relation.project.data.color};"> <div class="circle s6 mr2" riot-style="background-color: {opts.item.relation.project.data.color};"></div> <div>{opts.item.relation.project.data.name}</div> </div> <div class="f fm flex-fixed w80"> <div class="flex-fixed mr2 mr0-last" if="{opts.item.data.tags.length}" each="{tag in opts.item.data.tags}" data-is="atom-tag" label="{tag}"></div> </div> </div>', '', '', function(opts) {
});